import { callApi } from "./fetchTools";
import { HTTP_METHOD_GET, HTTP_METHOD_POST } from "../utils/constant";
import apis from "../common/apis";
import { IResponsePaging } from "./../models/base";
import { HTTP_METHOD_PUT } from "./../utils/constant";
import { IDelivery } from "../models/deliveryModel";
import IShippingInfo from "../models/shippingInfoModel";

export default {
  addDelivery: (query: any) => {
    return callApi<IDelivery>(HTTP_METHOD_POST, apis.user_delivery, query);
  },
  getDeliveries: () => {
    return callApi<IResponsePaging<IShippingInfo[]>>(
      HTTP_METHOD_GET,
      apis.user_delivery,
      {
        offset: 0,
        limit: 9999,
      }
    );
  },
  getDelivery: (id: string) => {
    return callApi<IDelivery>(
      HTTP_METHOD_GET,
      `${apis.user_delivery}${id}`,
      null
    );
  },
  updateAvatar: (query: any) => {
    return callApi<any>(HTTP_METHOD_PUT, apis.user_avatar_s3, query);
  },
  editDelivery: (query: any) => {
    const id = query._id;
    delete query.id;
    return callApi<any>(HTTP_METHOD_PUT, `${apis.user_delivery}${id}`, query);
  },
};
